import styled from 'styled-components';
import { AllieButton } from '../../../components/Buttons/Button';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 16px 32px;
`;

export const MetadataSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MetadataRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
`;

export const MetadataLabel = styled.span`
  font-family: 'Hanken Grotesk', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  color: #131316;
`;

export const MetadataValue = styled.span`
  font-family: 'Hanken Grotesk', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: #51525c;
`;

export const PreviewSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 10px;
  padding: 0 24px;
  min-height: 450px;
`;

export const PreviewImage = styled.img`
  width: 100%;
  max-width: 702px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  object-fit: contain;
`;

export const PreviewPlaceholder = styled.div`
  width: 100%;
  max-width: 702px;
  height: 400px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
  color: #51525c;
  font-family: 'Hanken Grotesk', sans-serif;
  font-size: 14px;
  text-align: center;
`;

export const NavigationControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
  width: 100%;
  position: relative;
  z-index: 5;
  pointer-events: auto;
`;

export const NavigationButton = styled(AllieButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px;
  background-color: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 24px;
  cursor: pointer;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  transition: background-color 0.2s ease;
  pointer-events: auto;
  position: relative;
  z-index: 10;

  &:hover:not(:disabled) {
    background-color: #f9fafb;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
    pointer-events: none;
  }
`;

export const PageSelector = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

